var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManualTimeEdits(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#6A00FF",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8267 50.0598C40.2427 49.5568 46.2617 43.5796 46.8194 36.1676C47.1827 31.3401 45.2393 26.9324 41.9771 23.9326L43.847 22.0627L44.7291 22.9449C45.3162 23.532 46.2682 23.532 46.8553 22.9449C47.4424 22.3577 47.4424 21.4058 46.8553 20.8187L42.9497 16.9131C42.3626 16.326 41.4107 16.326 40.8235 16.9131L40.8194 16.9172C40.2339 17.5027 40.2321 18.4515 40.8153 19.0393L41.7057 19.9365L39.5343 22.108C37.6644 20.977 35.5533 20.2381 33.2914 20.0119V16.9207H34.8038C35.6342 16.9207 36.3073 16.2475 36.3073 15.4172V15.4082C36.3073 14.5779 35.6342 13.9048 34.8038 13.9048H28.7631C27.9328 13.9048 27.2597 14.5779 27.2597 15.4082V15.4172C27.2597 16.2475 27.9328 16.9207 28.7631 16.9207H30.2755V20.0119C22.6755 20.7659 16.7041 27.2199 16.7041 35.0159C16.7041 43.6699 24.0491 50.6552 32.8267 50.0598ZM31.6764 25.9683H31.8905C32.6797 25.9683 33.3345 26.5785 33.3902 27.3657L33.9238 34.9144C33.9853 35.7843 33.2962 36.5238 32.4241 36.5238H31.1428C30.2708 36.5238 29.5817 35.7843 29.6431 34.9144L30.1767 27.3657C30.2324 26.5785 30.8873 25.9683 31.6764 25.9683Z",
    fill: "#6A00FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualTimeEdits);
export default __webpack_public_path__ + "static/media/manual-time-edits.f258b27386ac39e3b07f94a0457bd90e.svg";
export { ForwardRef as ReactComponent };